export default __webpack_public_path__ + "static/media/bed-side-right.0dbc700a.jpg";